import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import KeyFeatures from './components/KeyFeatures';
import CourseModules from './components/CourseModules';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAFAF8]">
      <Navbar />
      <Hero />
      <ValueProposition />
      <KeyFeatures />
      <CourseModules />
      <CTASection />
      <Footer />
    </div>
  );
}
